import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { ActivatedRoute} from '@angular/router';

import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';

import { ConceptFormParentService } from '../utils/concept-form-parent.service';
import { FieldItemComponent } from '../../field-item/field-item.component';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { NgClass, NgStyle } from '@angular/common';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';

@Component({
    selector: 'concept-form-sequential',
    templateUrl: './concept-form-sequential.component.html',
    standalone: true,
    imports: [NgClass, NgStyle, AfTranslateDirective, FieldItemComponent]
})
export class ConceptFormSequentialComponent implements OnInit, OnDestroy {
  skin: string = this.globalCfg.skin;
  isLanding: boolean = true;
  params: any = this.route.snapshot.params
  currentComponent: string = this.route.snapshot.data['componentName'];
  locationName: any = this.route.snapshot.data['name'];
  fieldContainerId:any = this.route.snapshot.params['fieldContainerId'];
  conceptObjectId:any = this.route.snapshot.params['conceptObjectId'];
  conceptForm: any = this.conceptFormParent.configureConceptFormObject(this);

  constructor(private globalCfg: GlobalCfgFactory,
    public loader: LoaderFactory,
    private route: ActivatedRoute,
    private commonUtilsService: CommonUtilsService,
    private conceptFormParent: ConceptFormParentService) {
  }

  @Input() concept: any = null;
  @Input() public: boolean = false;
  @Input() evaluationId: any = null;
  @Input() footerConceptPublic: any = null;
  @Input() disabledSave: any = null;
  @Input() formalitiesList: any = null;

  @Output() launchAction = new EventEmitter();

  ngOnDestroy(){
    this.conceptFormParent.ngOnDestroy();
  }

  ngOnInit(){
    this.conceptFormParent.onInit(this);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.conceptFormParent.onChanges(this, changes);
  }

  changesInEvaluatedConcept(e:any){
    this.conceptFormParent.changesInEvaluatedConcept(e.field, this);
  }

  changeConceptFromField(template:any){
    this.conceptFormParent.changeConceptFromField(template, this)
  }

  startPoll(){
    this.conceptForm.fieldSelected = {
      nextCountValue: 1
    }
    this.configureSelectSequentialField();
    this.conceptForm.startedPoll = true;
  }

  nextOrSavePoll(){
    if(this.conceptForm.fieldSelected?.lastField){
      this.checkSavePoll();
    }else{
      this.nextQuestionPoll();
    }
  }

  nextQuestionPoll(){
    let that:any = this.conceptForm;
    // if(!that.viewEditConcept && that.fieldSelected && that.fieldSelected?.required && !that.fieldSelected.evaluatedValue.completePoll){
    if(!that.viewEditConcept && that.fieldSelected.required && this.commonUtilsService.checkField(that.fieldSelected)){
      that.fieldSelected.error = true;
    }else if(!that.fieldSelected.error){
      this.configureSelectSequentialField();
    }
  }

  configureSelectSequentialField(){
    let that:any = this.conceptForm;
    let selectedField:boolean = false;
    that.sequentialFieldsVisibility.forEach((field:any) => {
      field.selected = false;
      if(!selectedField && field.countFieldVisible !== null && that.fieldSelected.nextCountValue === field.countFieldVisible){
        selectedField = true;
        that.fieldSelected = field;
        that.fieldSelected.error = false;
        that.fieldSelected.nextCountValue = that.fieldSelected.countFieldVisible+1;
        that.fieldSelected.prevCountValue = that.fieldSelected.countFieldVisible-1;
        field.selected = true;
      }
    });
  }

  previousQuestionPoll(){
    let selectedField:any = false;
    this.conceptForm.sequentialFieldsVisibility.forEach((field:any) => {
      field.selected = false;
      if(!selectedField && field.countFieldVisible !== null && this.conceptForm.fieldSelected.prevCountValue === field.countFieldVisible){
        selectedField = true;
        this.conceptForm.fieldSelected = field;
        this.conceptForm.fieldSelected.error = false;
        field.selected = true;
      }
    });
  }

  checkSavePoll(){
    let that:any = this.conceptForm;
    // if(!that.viewEditConcept && that.fieldSelected && that.fieldSelected.required && !that.fieldSelected.evaluatedValue.completePoll){
    if(!that.viewEditConcept && that.fieldSelected.required && this.commonUtilsService.checkField(that.fieldSelected)){
      that.fieldSelected.error = true;
    }else{
      this.conceptFormParent.savePublicConcept(this);
    }
  }
}
